// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e228f368","239":"54ecbefa","453":"210d8974","732":"d697afb1"}[chunkId] + ".chunk.js";
};